import React from 'react';
import { Shimmer, ShimmerElementType, mergeStyles } from '@fluentui/react';

const wrapperClass = mergeStyles({
  padding: 2,
  selectors: {
    '& > .ms-Shimmer-container': {
      margin: '10px 0',
      border: 'none',
    },
  },
});

const shimmerWithElementFirstRow = [
  { type: ShimmerElementType.line, height: 30 },
  { type: ShimmerElementType.gap, width: 10, height: 30 },
  { type: ShimmerElementType.line, height: 30 },
  { type: ShimmerElementType.gap, width: 10, height: 30 },
  { type: ShimmerElementType.line, height: 30 },
  { type: ShimmerElementType.gap, width: 10, height: 30 },
  { type: ShimmerElementType.line, height: 30 },
  { type: ShimmerElementType.gap, width: 10, height: 30 },
  { type: ShimmerElementType.line, height: 30 },
  { type: ShimmerElementType.gap, width: 10, height: 30 },
];

const shimmerWithElementSecondRow = [
  { type: ShimmerElementType.circle, height: 24 },
  { type: ShimmerElementType.gap, width: '2%', height: 24 },
  { type: ShimmerElementType.line, height: 16, width: '20%' },
  { type: ShimmerElementType.gap, width: '100%', height: 16 },
];

export const AdScheduleShimmer = () => (
  <div className={wrapperClass}>
    <Shimmer shimmerElements={shimmerWithElementFirstRow} />
    <Shimmer shimmerElements={shimmerWithElementFirstRow} />
    <div style={{ marginTop: 50 }}>
      <Shimmer width={100} />
      <br />
      <Shimmer shimmerElements={shimmerWithElementSecondRow} />
      <Shimmer shimmerElements={shimmerWithElementSecondRow} />
    </div>
    <div style={{ marginTop: 50 }}>
      <Shimmer width={100} />
      <br />
      <Shimmer shimmerElements={shimmerWithElementSecondRow} />
      <Shimmer shimmerElements={shimmerWithElementSecondRow} />
    </div>
  </div>
);
